/**
 * 仓储管理模块路由。
 * 当前先挂载库位管理页面，后续仓库、库区等页面也可以继续挂到这个模块下。
 */
const defectRouter = [
    {
        // 仓储管理一级路由，统一使用主布局组件承载。
        path: '/defect',
        component: () => import('@/layout/LayoutIndex.vue'),
        meta: { title: '缺陷管理', icon: 'system', requireAuth: true },
        name: 'defect',
        redirect: '/home',
        children: [

            {
                // 缺陷类型页面路由。
                path: '/defect/defectType',
                component: () => import('@/views/defects/defectType/DefectType.vue'),
                name: 'DefectType',
                meta: { title: '缺陷类型', requireAuth: true }
            },
            {
                // 缺陷等级页面路由。
                path: '/defect/defectLevel',
                component: () => import('@/views/defects/defectLevel/DefectLevel.vue'),
                name: 'DefectLevel',
                meta: { title: '缺陷等级', requireAuth: true }
            },
            {
                // 缺陷等级页面路由。
                path: '/defect/defectPosition',
                component: () => import('@/views/defects/defectPosition/DefectPosition.vue'),
                name: 'DefectPosition',
                meta: { title: '缺陷等级', requireAuth: true }
            },
            {
                // 缺陷等级页面路由。
                path: '/defect/defectInfoEntity',
                component: () => import('@/views/defects/defectInfoEntity/DefectInfoEntity.vue'),
                name: 'DefectInfoEntity',
                meta: { title: '缺陷等级', requireAuth: true }
            },
        ]
    }
]

export default defectRouter
